import { setUpStore } from "../helper/plugins/configure-store";

const store = setUpStore();

export default store;
